import React from 'react';
import SrLink from 'client/components/SrLink/SrLink';

const SrEducationalTourCard = () => (
  <div className='promptCard SrEducationalTourCard'>
    <div className='textContainer'>
      <span className='category'>plan your tour day</span>
      <span className='headline'>
        See multiple rentals at once
      </span>
      <span className='subhead'>
        You only have to talk to Sunroom! No need to talk to different landlords.
      </span>
    </div>
    <div className='buttonContainer'>
      <SrLink to='/feed'>
        <span className='button white small'>Add rentals to your tour</span>
      </SrLink>
    </div>
  </div>
);

SrEducationalTourCard.displayName = 'SrEducationalTourCard';

export default SrEducationalTourCard;
